const assign = require('lodash/assign');
const cache = require('./cache');
const orders = require('./orders');
const text = require('./text');
const features = require('./features');
const priceFacets = require('./price-facets');
const variants = require('./variants').default;
const optionsSuccess = require('./utilities/options-success');
const events = require('./events');

const defaultOptions = {
  buildCache: true,
  force: false,
};

function applyDefaultOptions(options = {}) {
  return {
    ...defaultOptions,
    ...options,
  };
}

/**
 * @param {object} localizeModule Module with `localize` method exposed.
 * @param {object} [options] optionasl options object.
 * @param {function} [options.success] success callback.
 * @param {function} [options.error] error callback.
 */
function callLocalizer(localizeModule, options = {}) {
  return new Promise((resolve) => {
    localizeModule.localize({
      ...options,
      success: () => {
        resolve();
      },
      error: (error) => {
        events.trigger(events.constants.ERROR, { error });
        resolve();
      },
    });
  });
}

function localizePriceFacets(options = {}) {
  return callLocalizer(priceFacets, options);
}

function localizeVariants(options = {}) {
  return callLocalizer(variants, options);
}

function localizeFeatures() {
  return callLocalizer(features);
}

function localizeAll(options = {}) {
  return Promise
    .all([localizeVariants(options), localizeFeatures()])
    .then(() => {
      localizePriceFacets();
      orders.localize();
      text.localize();
      optionsSuccess(options);
    }).catch((error) => {
      events.trigger(events.constants.ERROR, { error });
    });
}


/**
 * Localize a webpage integrated with Flow. Will run through all of the localization types:
 *
 * - variants
 * - features
 * - orders
 * - text
 *
 * @param {Object} opts
 * @param {Boolean} opts.buildCache - Build the variant and order caches on Flow.cache
 */
function localize(opts = {}) {
  const options = applyDefaultOptions(opts);
  if (options.buildCache) {
    Flow.cache = assign({}, Flow.cache, cache.buildCache());
  }

  return localizeAll(options);
}

module.exports = localize;



// WEBPACK FOOTER //
// ./static/js/v0/localize.js